<template>
  <section>
    <div class="row">
      <div class="col-sm-8 col-12">
        <h2 class="mb-2">{{ $t('message.menu.invite_friends') }}</h2>
        <p class="text-comment">
          {{ $t('message.invite_friends.receive_credit_detail', { credits: globalState.configData.invite_friend_credits }) }}
        </p>
        <div class="row mt-4 no-gutters">
          <div class="col-12">
            <label>{{ $t('message.invite_friends.share_your_link') }}</label>
            <div class="input-group flex-fill">
              <input ref="referralCode"
                     class="form-control flex-fill"
                     type="text"
                     :value="'beneat.co/chat-booking?c='+referralCode.referral_code">
              <div class="input-group-append">
                <button class="btn btn-info"
                        @click="copyReferralCode"
                        v-clipboard:copy="referralCode.url_referral_code">
                  {{ $t(isCopiedReferralCode) }}
                </button>
              </div>
            </div>
            <!-- /.form-inline -->

            <div class="my-4">
              <hr>
            </div>

            <div class="my-3">
              <a class="btn btn-block -indigo my-2"
                 :href="'https://www.facebook.com/sharer/sharer.php?u='+referralCode.url_referral_code"
                 target="_blank">
                <i class="fab fa-facebook-f mr-3"></i> Share on Facebook
              </a>
            </div>

            <div class="my-3">
              <a class="btn btn-block -blue my-2"
                 :href="'https://twitter.com/intent/tweet?url='+referralCode.url_referral_code"
                 target="_blank">
                <i class="fab fa-twitter mr-3"></i> Share on Twitter
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4 col-12">
        <div class="card">
          <div class="card-body shadow-sm">
            <div class="row no-gutters text-remark text-dark">
              <div class="col-12">
                <div class="mb-3">
                  <i class="fal fa-piggy-bank fa-2x"></i>
                </div>
                <h3>{{ $t('message.credit.your_credits') }}</h3>
              </div>
              <div class="col-8 text-info">
                {{ $t('message.credit.pending_status') }}
              </div>
              <div class="col-4 text-right">
                <label>{{ user.pendingCredits | currency }}</label>
              </div>
              <div class="col-12"><hr></div>
              <div class="col-8 text-info">
                {{ $t('message.credit.available_status') }}
              </div>
              <div class="col-4 text-right">
                <label>{{ user.totalCredits | currency }}</label>
              </div>
              <div class="col-12"><hr></div>
              <div class="col-12">
                <router-link to="/user/credits"
                             class="btn btn-block btn-info">
                  {{ $t('message.invite_friends.view_transactions') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section how do invites work? -->
    <section class="mt-4">
      <div class="row">
        <div class="col-12">
          <h3>{{ $t('message.invite_friends.how_do_invites_work') }}</h3>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12 col-sm-4">
          <div class="mb-4">
            <i class="fal fa-link fa-3x -status-pending"></i>
          </div>
          <h4>{{ $t('message.invite_friends.how_do_invites_work_title01') }}</h4>
          <p class="text-comment">{{ $t('message.invite_friends.how_do_invites_work_detail01') }}</p>
        </div>
        <div class="col-12 col-sm-4">
          <div class="mb-4">
            <i class="fal fa-hand-holding-usd fa-3x -status-new"></i>
          </div>
          <h4>{{ $t('message.invite_friends.how_do_invites_work_title02', { credits: globalState.configData.register_credits }) }}</h4>
          <p class="text-comment">{{ $t('message.invite_friends.how_do_invites_work_detail02', { credits: globalState.configData.register_credits }) }}</p>
        </div>
        <div class="col-12 col-sm-4">
          <div class="mb-4">
            <i class="fal fa-piggy-bank fa-3x -status-new"></i>
          </div>
          <h4>{{ $t('message.invite_friends.how_do_invites_work_title03', { credits: globalState.configData.invite_friend_credits }) }}</h4>
          <p class="text-comment">{{ $t('message.invite_friends.how_do_invites_work_detail03', { credits: globalState.configData.invite_friend_credits }) }}</p>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Loader from '../loader/Loader'

  export default {
    components: {
      Loader
    },
    data () {
      return {
        refCode: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        referralCode: 'referralCode/getReferralCode',
        user: 'auth/getUser'
      }),
      isCopiedReferralCode () {
        return (this.refCode) ? 'message.button.copied' : 'message.button.copy'
      }
    },
    methods: {
      copyReferralCode () {
        this.refCode = this.$refs.referralCode.value
      }
    },
    mounted () {
      this.$store.dispatch('referralCode/LOAD_REFERRAL_CODE_DETAIL', this.user.id)
    }
  }
</script>

<style scoped>
  .button {
    margin: 0 0.5rem;
    height: 44px;
    line-height: 44px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Invite.vue